module.exports = __webpack_public_path__ + "img/przedszkole1.60dc886d.jpg";